<template>
  <div class="alert">
    <div class="alert__description">
      <p class="alert__text">
        <slot></slot>
      </p>
    </div>
    <div class="alert__btn">
      <div class="btn-container">
        <CancelButton class="dialog-btn" @click="onClickNg">
          {{ ngText }}
        </CancelButton>
        <EnterButton class="dialog-btn" @click="onClickOk">
          {{ okText }}
        </EnterButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import EnterButton from "./EnterButton.vue";
import CancelButton from "./CancelButton.vue";
export default defineComponent({
  name: "Alert",
  components: {
    EnterButton,
    CancelButton,
  },
  props: {
    ngText: {
      type: String,
      default: "",
    },
    onClickNg: {
      type: Function,
      default: null,
    },
    okText: {
      type: String,
      default: "",
    },
    onClickOk: {
      type: Function,
      default: null,
    },
  },
});
</script>

<style scoped>
.alert {
  background: #ededea;
  background-image: linear-gradient(45deg, #e1e0dd 25%, transparent 0),
    linear-gradient(45deg, transparent 75%, #e1e0dd 0),
    linear-gradient(45deg, #e1e0dd 25%, transparent 0),
    linear-gradient(45deg, transparent 75%, #e1e0dd 0);
  background-size: 150px 150px;
  background-position: 0 0, 75px 75px, 75px 75px, 150px 150px;
}
.alert__text {
  color: #455765;
}
.btn-container {
  margin-top: 2rem;
}
.dialog-btn {
  margin: 0 3rem;
}
</style>
